import type { SyncAdapter, SyncRemoteFile } from './sync-adapter.js';
import type { BackupEnvelope } from '../storage/backup.js';

/**
 * File System Access adapter — when the browser supports `showDirectoryPicker`,
 * the user can pin a local folder (e.g., a synced Drive/Dropbox folder) and
 * Wean writes/reads backup files there. Still local-first: the browser
 * mediates file I/O, and Wean does not speak any cloud API directly.
 */
export const fileSystemAdapter: SyncAdapter = {
  meta: {
    id: 'fs',
    name: 'Local folder',
    description: 'Read/write backups in a folder you choose. Works with Drive/Dropbox/iCloud sync clients.',
    requiresNetwork: false,
  },
  async isAvailable() {
    return typeof (window as unknown as { showDirectoryPicker?: unknown }).showDirectoryPicker === 'function';
  },
  async isConnected() {
    return false; // Persistent handle storage is out of scope for MVP wiring.
  },
  async connect() { throw new Error('Not implemented in MVP. Adapter is a stub.'); },
  async disconnect() { /* no-op */ },
  async list(): Promise<SyncRemoteFile[]> { return []; },
  async upload(_env: BackupEnvelope): Promise<SyncRemoteFile> { throw new Error('Not implemented in MVP.'); },
  async download(_id: string): Promise<BackupEnvelope> { throw new Error('Not implemented in MVP.'); },
  async remove(_id: string) { throw new Error('Not implemented in MVP.'); },
};
